module.exports = __webpack_public_path__ + "static/media/feet-on-pavement.d8b4d92d.jpg";